import { useState } from 'react'
import BotonTres from '../../ui/ButtonPopup'
import { Horario } from '@/types'
import {PopupHorarios} from '../../popup'

interface Props {
  horarios: Horario[]
  onHorariosChange: (horarios: Horario[]) => void
}

const EditarHorariosProfesionalForm: React.FC<Props> = ({
  horarios,
  onHorariosChange,
}) => {
  const [showPopup, setShowPopup] = useState(false)

  return (
    <div>
      <BotonTres type="button" className='mt-4 h-8 px-4' onClick={() => setShowPopup(true)}>
        Editar Horarios
      </BotonTres>

      {showPopup && (
        <PopupHorarios
          initialHorarios={horarios}
          onClose={() => setShowPopup(false)}
          onConfirm={onHorariosChange}
          
        />
      )}
    </div>
  )
}

export default EditarHorariosProfesionalForm;
